import moment from "moment";
import { ShortCrypt } from "short-crypt";
import * as XLSX from 'xlsx';

const shortCryptKey = "JwOwwUuFqcA9vEuZiBdT0w==";
const shortCrypt = new ShortCrypt(shortCryptKey);

export const TOKEN_HEADER_KEY = "tovform-access-token";

const ENV_PROD = "PROD";
const ENV_DEV = "DEV";

export const getEnv = () => {
    if (process.env.NODE_ENV === "development") {
        return ENV_DEV;
    }
    return ENV_PROD;
}

export const getBaseUri = () => {
    let env = getEnv();
    let uri = window.location.hostname;
    if (env === "DEV") {
        uri = "http://" + uri + "/tovform"
    } else {
        uri = "https://" + uri;
    }
    return uri;
}

export const getUIBaseUri = () => {
    let env = getEnv();
    let uri = window.location.hostname;
    if (env === "DEV") {
        uri = "http://" + uri + ":" + window.location.port;
    } else {
        uri = "https://" + uri;
    }
    return uri;
}

export const getMediaUri = () => {
    return getBaseUri() + "/media/v1";
}

export const encrypt = (plainText) => {
    let cipher = shortCrypt.encryptToURLComponent(plainText.toString());
    return cipher;
}
export const decrypt = (cipher) => {
    let decrypted = shortCrypt.decryptURLComponent(cipher);
    if (decrypted) {
        return new TextDecoder().decode(decrypted.buffer);
    }
    return null;
}

const buildKey = (key) => {
    let prefix = "SHOP_";
    if (process.env.NODE_ENV === "development") {
        prefix += "DEV_"
    }
    return prefix + key;
}

export const localdb = {
    put: (k, v) => {
        localStorage.setItem(buildKey(k), v)
    },
    get: (k) => {
        return localStorage.getItem(buildKey(k));
    },
    remove: (k) => {
        localStorage.removeItem(buildKey(k));
    },
    getKey: (k) => {
        return buildKey(k);
    }
}


export const getAuthHeader = () => {
    var authHeader = {}
    if (localdb.get("userData")) {
        const userData = JSON.parse(localdb.get("userData"));
        authHeader[TOKEN_HEADER_KEY] = userData.authToken;
    }
    return authHeader;
}

export const getAuthToken = () => {
    if (localdb.get("userData")) {
        const userData = JSON.parse(localdb.get("userData"));
        return userData.authToken;;
    }
}

export const paginationUtil = {
    getParams: (paginatorConfig) => {
        if (!paginatorConfig || paginatorConfig.pageNumber == null || !paginatorConfig.pageSize == null) {
            return "?limit=10&offset=0";
        }
        const offset = (paginatorConfig.pageNumber) * paginatorConfig.pageSize;
        let queryStr = "?limit=" + paginatorConfig.pageSize + "&offset=" + offset;
        return queryStr;
    },
    getConfig: (config) => {
        if (!config) {
            return { pageNumber: 0, pageSize: 10 };
        }
        return config;
    }
}

export const getThumbnailImage = (files) => {
    if (!files || files.length === 0) {
        return null;
    }
    let thumbnail = files.filter(file => file.isThumbnail === 1)[0];
    if (!thumbnail) {
        thumbnail = files[0];
    }
    return getMediaUri() + "/" + thumbnail.location;
}

export const getThumbnailFromMediaString = (media) => {
    if (!media || media.trim() === '') {
        return null;
    }
    let mediaFiles = media.split(",");
    let thumbnail = mediaFiles.filter((file) => {
        return file.split('|')[0] == 1
    })[0];
    if (!thumbnail) {
        thumbnail = mediaFiles[0];
    }
    let mediaUrl = thumbnail.split('|')[1].trim()
    return getMediaUri() + "/" + mediaUrl;
}

export const capitalizeFirstLetter = (string) => {
    if (typeof string !== 'string' || string.length === 0) {
        return string;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const convertDate = (sqlDateStr) => {
    const dateObject = moment(sqlDateStr);
    const formattedDate = dateObject.format("MMMM Do, YYYY");
    return formattedDate;
}

export const hasLink = (links, linkName) => {
    if (!links || !Array.isArray(links) || !linkName) {
        return false;
    }
    let resLinks = links.filter((link) => link.name.toLowerCase() == linkName.toLowerCase())
    return resLinks.length > 0;
}


const mobileNumberPattern = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isValidEmail = (email) => {
    return emailPattern.test(email);
}

export const isValidMobileNumber = (mobileNumber) => {
    return mobileNumberPattern.test(mobileNumber);
}

export const isValidNumber = (number) => {
    return !isNaN(number);
}

export const getImageDimensionsFromUrl = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = function () {
            resolve({
                width: this.naturalWidth,
                height: this.naturalHeight
            });
        };
        img.onerror = function () {
            reject(new Error("Could not load image at " + url));
        };
        img.src = url;
    });
}

export const readXLSX = (event, callback) => {
    try {
        const file = event.target.files[0];
        const allowedExtensions = ['xlsx', 'xls', 'csv', 'numbers'];
        const extension = file.name.split('.').pop().toLowerCase();

        if (!allowedExtensions.includes(extension)) {
            throw Error('File not supported!')
        }
        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = (e) => {
            try {
                const data = e.target.result;
                const workbook = XLSX.read(data, { type: "array", cellNF: true  });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = XLSX.utils.sheet_to_json(worksheet);
                callback(json);
            } catch (e) {
                throw e;
            }
        }
        reader.readAsArrayBuffer(event.target.files[0]);
    } catch (e) {
        throw e;
    }
}

export const buildImportedContacts = (json) => {
    let contactArr = [];
    json.forEach(item => {
        let contact = {};
        for (const val of Object.values(item)) {
            if (isValidEmail(val)) {
                contact.email = val;
                break;
            }
        }
        if (contact.email) {
            contact.displayName = getNameFromImportedRow(item);
            contactArr.push(contact);
        }
    });
    return contactArr;
}

export const getNameFromImportedRow = (row) => {
    let firstName = null;
    let lastName = null;
    firstName = row["First Name"] || row["first name"] || row["firstName"] || row["FirstName"] || row["firstname"] || row["FIRSTNAME"] || row["FIRST_NAME"] || row["first_name"] || row["Name"] || row["name"];
    lastName = row["Last Name"] || row["last name"] || row["lastName"] || row["LastName"] || row["lastname"] || row["last_name"] || row["LASTNAME"] || row["LAST_NAME"];
    let displayName = firstName;
    if (displayName && lastName) {
        displayName += " " + lastName;
    }
    return displayName;
}

export const uploadImageSizes = {
    profile: {
        label: "Profile",
        width: 200,
        height: 200
    },
    fullSize: {
        label: "Full size",
        width: "99%",
        height: "100%",
    },
    ratio_1_1: {
        label: "Ratio 1:1",
        width: 250,
        height: 250
    },
    ratio_2_1: {
        label: "Ratio 2:1",
        width: "99%",
        aspectRatio: "2/1"
    },
    ratio_1_2: {
        label: "Ratio 1:2",
        width: "50%",
        height: "100%",
    },
}

export const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const CHART_COLORS = [
    '#9394f0',
    '#14c4b4',
    '#fa938e',
    '#98bf45',
    '#d397ff',
    '#acfb78',
    '#616eb8',
    '#9fb8d7',
    '#e79d9e',
    '#e84a81',
    '#f0c186',
    '#3adbf7',
    '#b4edd6',
    '#efaac1',
    '#fb7577',
    '#71aef2',
    '#fb8a27',
    '#fada37',
    '#f660b0',
    '#e180f0',
]


export const AvatarUtil = {
    avatarColors: [
        "#941CE9",
        "#BB6DC6",
        "#01D6FF",
        "#74D680",
        "#058D79",
        "#48B8A5",
        "#00089C",
        "#74B3CE",
        "#058D79",
        "#A97990",
        "#FFD600",
        "#D7AD00",
        "#96DEFE",
        "#FF0038",
        "#0BA575",
        "#FF3D88",
        "#406D96",
        "#06C1BB",
        "#FF5E79",
    ],
    getAvatarColor: () => {
        const randomIndex = Math.floor(Math.random() * AvatarUtil.avatarColors.length);
        return AvatarUtil.avatarColors[randomIndex];
    },

    getAvatarInitial: (str) => {
        if (str) {
            return str.charAt(0).toUpperCase();
        }
    }
}